
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-simple-hook-modal.cjs.production.min.js')
} else {
  module.exports = require('./react-simple-hook-modal.cjs.development.js')
}
